import React from 'react';
import type { CoffeeRateInterface } from '../types';

interface CardImageProps {
    coffeeData: CoffeeRateInterface;
    coffeeIconUrl: string;
    imageUrl: string | null;
    imageLoaded: boolean;
    fetchFailed: boolean;
    isVisible: boolean;
    onImageLoad: () => void;
    onImageError: () => void;
    showUserOverlay?: boolean;
    overlayClear: boolean;
}

/**
 * Photo + placeholder + (optional) user info overlay.
 * Original class names; image takes the full image-section.
 */
export const CardImage: React.FC<CardImageProps> = ({
    coffeeData,
    coffeeIconUrl,
    imageUrl,
    imageLoaded,
    fetchFailed,
    isVisible,
    onImageLoad,
    onImageError,
    showUserOverlay,
    overlayClear,
}) => {
    const placeholderVisible = !imageLoaded || !imageUrl;
    const showUser = showUserOverlay && overlayClear && coffeeData.user;

    return (
        <>
            {placeholderVisible && (
                <div className={`image-placeholder${fetchFailed ? ' failed' : ''}`}>
                    <img
                        src={coffeeIconUrl}
                        alt={fetchFailed ? 'Failed to load image' : 'Loading…'}
                        style={fetchFailed ? { opacity: 0.5 } : undefined}
                        onError={(e) => { e.currentTarget.style.visibility = 'hidden'; }}
                    />
                    {fetchFailed && <div className='fetch-error'>Failed to load image</div>}
                </div>
            )}
            {isVisible && imageUrl && !fetchFailed && (
                <img
                    src={imageUrl}
                    alt={coffeeData.coffeeType}
                    className={`coffee-image${imageLoaded ? ' loaded' : ''}`}
                    onLoad={onImageLoad}
                    onError={onImageError}
                />
            )}
            {showUser && (
                <div className='user-info-overlay'>
                    {coffeeData.user!.userEmoji && (
                        <span className='user-emoji'>{coffeeData.user!.userEmoji}</span>
                    )}
                    <div className='username'>.{coffeeData.user!.username}</div>
                </div>
            )}
        </>
    );
};
